import { useCallback } from 'react';
import { PortfolioPanel } from './components/PortfolioPanel';
import { NonPortfolioPanel } from './components/NonPortfolioPanel';
import '../../../../scss/_byPropertyPanel.scss';
import { GenericAlertPopup, ProgressSpinner } from '@apply/components';
import { useAssignedUsersQuery, useRefreshUserManagement } from '../../../../../manageusers/queries/userManagementQueries';

export const ByPropertyPanel: React.FC = () => {
    const { data: assignedUsers = [], isLoading, error } = useAssignedUsersQuery();
    const refreshProperties = useRefreshUserManagement();

    if (error) {
        GenericAlertPopup({
            title: 'Error',
            children: error.message || 'Failed to load assigned user data. Please try again.',
            width: '350px',
        });
    }

    return (
        <div className='byPropertyPanel'>
            {isLoading && (
                <div className='loadingOverlay'>
                    <div className='stickySpinner'>
                        <ProgressSpinner />
                    </div>
                </div>
            )}
            <div style={{ opacity: isLoading ? 0.7 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                {assignedUsers.map((loan, index) =>
                    loan.isPortfolio ? (
                        <PortfolioPanel
                            key={`portfolio-${index}`}
                            properties={loan.properties}
                            onRefresh={refreshProperties}
                        />
                    ) : (
                        <NonPortfolioPanel
                            key={`nonportfolio-${index}`}
                            properties={loan.properties}
                            onRefresh={refreshProperties}
                        />
                    )
                )}
                {!isLoading && assignedUsers.length < 1 && (
                    <div style={{ textAlign: 'center', paddingTop: '3rem' }}>
                        <h3>You don't currently have any projects.</h3>
                    </div>
                )}
            </div>
        </div>
    );
};
